/**
 * ChatFab Component
 * Floating Action Button for opening the chat dialog
 */

import React from "react";
import { Box, Fab, Tooltip, Zoom, useTheme, alpha } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { useTranslation } from "react-i18next";

const ChatFab = ({ onClick, mainColor }) => {
        const { t } = useTranslation();
        const theme = useTheme();

        return (
                <Tooltip title={t("ai-chat-assistant") || "AI Assistant"} placement="left" arrow>
                        <Zoom in={true}>
                                <Box
                                        className="chat-icon-wrapper"
                                        sx={{
                                                position: "fixed",
                                                bottom: { xs: 16, md: 24 },
                                                right: { xs: 16, md: 24 },
                                                zIndex: theme.zIndex.speedDial,
                                                "&::before": {
                                                        borderColor: mainColor,
                                                },
                                                "&:hover::before": {
                                                        animationPlayState: "paused",
                                                },
                                        }}
                                >
                                        <Fab
                                                color="primary"
                                                aria-label="ai-chat"
                                                sx={{
                                                        backgroundColor: mainColor,
                                                        boxShadow: `0 4px 20px ${alpha(mainColor, 0.4)}`,
                                                        animation: "chatPulse 2s ease-in-out infinite, float 3s ease-in-out infinite",
                                                        animationDelay: "0s, 0s",
                                                        transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                                                        "&:hover": {
                                                                backgroundColor: alpha(mainColor, 0.9),
                                                                transform: "scale(1.1) rotate(-10deg)",
                                                                boxShadow: `0 6px 24px ${alpha(mainColor, 0.6)}`,
                                                                animationPlayState: "paused",
                                                        },
                                                }}
                                                onClick={onClick}
                                        >
                                                <ChatIcon />
                                        </Fab>
                                </Box>
                        </Zoom>
                </Tooltip>
        );
};

export default ChatFab;

